import React, { useState } from "react";
import { Card, Input, Button, message, Image, Form } from "antd";
import Cookies from "js-cookie";
import axios from "axios";
import { ArrowLeftOutlined, EyeOutlined, EyeInvisibleOutlined, MailOutlined } from "@ant-design/icons";
// import "../verifymail.css";
import "../../../GlobalCss/SPF/verifymail.css";
import { Link } from "react-router-dom";

const ResetPassword = ({ history }) => {
  const [form] = Form.useForm();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const tenantName = Cookies.get("tenant_name")

  const email = Cookies.get("email") || "";
  const key = Cookies.get("key") || "";

  const validatePassword = (_, value) => {
    if (
      !value ||
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(value)
    ) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(
        "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character."
      )
    );
  };

  const handleSave = async () => {
    try {
      // Get validated form values
      const values = await form.validateFields();
  
      // Check if passwords match
      if (values.newPassword !== values.confirmPassword) {
        setPasswordsMatch(false);
        message.error("Passwords do not match.");
        return;
      }
      
      setPasswordsMatch(true);
  
      axios
        .post(`${process.env.REACT_APP_BASE_URL}Auth/reset/update-password`, {
          email: email,
          newPassword: values.newPassword, // Use values from form
          key: key,
        })
        .then((response) => {
          message.success(response.data.message);
          Cookies.remove("email");
          Cookies.remove("key");
          setTimeout(() => {
            history.push(`/${tenantName}`);
          }, 1500);
        })
        .catch((error) => {
          message.error("Failed to update password. Please try again.");
        });
    } catch (errorInfo) {
      console.error("Validation Failed:", errorInfo);
    }
  };
  

  return (
    <>
      <div className="mobile-verification-container">
        <div className="signin-image">
          <Image
            src="/Images/illus3.png"
            style={{
              border: "none",
              width: "90%",
              height: "100%",
            }}
            showPreviewIcon={false}
            preview={false}
          />
        </div>
        <main className="verification-main">
          <div className="verification-content">
            <h2 style={{ color: "#A0AEFF", textAlign: "center" }}>Password Reset</h2>
            <div className="verification-card">
              <header className="verification-header">
                <p style={{ color: "#718096", textAlign: "center" }}>Set a New Password</p>
              </header>
              <div style={{ width: 350 }}>
                <Form form={form} onFinish={handleSave}>
                  <Form.Item>
                    <Input
                      value={email}
                      disabled
                      addonAfter={<MailOutlined style={{ cursor: "default", color: "rgba(0, 0, 0, 0.25)" }} />}
                      style={{ marginBottom: 10 }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="newPassword"
                    rules={[
                      { required: true, message: "Please enter your new password." },
                      { validator: validatePassword },
                    ]}
                  >
                    <Input.Password
                      placeholder="New Password"
                      iconRender={(visible) =>
                        visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                      }
                      style={{ marginBottom: 10 }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="confirmPassword"
                    dependencies={["newPassword"]}
                    rules={[
                      { required: true, message: "Please confirm your new password." },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("newPassword") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error("Passwords do not match."));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      placeholder="Confirm New Password"
                      iconRender={(visible) =>
                        visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                      }
                      style={{ marginBottom: 10 }}
                    />
                  </Form.Item>

                  <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                    Save
                  </Button>
                </Form>
              </div>
            </div>
            <h5 style={{ color: "#3B52DF" }}>
              <Link to={`/${tenantName}`}>
                <ArrowLeftOutlined /> Go to Login
              </Link>
            </h5>
          </div>
        </main>
      </div>
    </>
  );
};

export default ResetPassword;
